<template>
  <div class="mx-3">
    <div v-if="context == 'partner'" class="mx-auto">
      <b-row v-if="!count">No ratings</b-row>
      <b-row v-else>
        <b-col v-b-tooltip.hover :title="`${average} / 5`">
          <img
            v-for="(star, index) in starAmount"
            :key="index"
            class="star"
            :src="star"
          />
        </b-col>
        <b-col>{{ count }} Ratings</b-col>
      </b-row>
    </div>
    <div v-if="context == 'job'">
      <b-row v-if="!count">
        <div class="stars-container">No ratings</div>
      </b-row>
      <b-row v-else>
        <b-col class="p-0">
          <div class="stars-container">
            <img
              v-for="(star, index) in starAmount"
              :key="index"
              class="star"
              :src="star"
            />
          </div>
          <p>{{ count }} Ratings</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import star_full from '../assets/images/star_full.svg';
import star_empty from '../assets/images/star_empty.svg';
export default {
  props: ['context', 'count', 'average'],
  computed: {
    starAmount() {
      const rounded = Math.round(this.average);
      const result = [];
      for (let i = 0; i < 5; i++) {
        result.push(rounded >= i + 1 ? star_full : star_empty);
      }
      return result;
    },
  },
};
</script>
<style scoped>
#rating-tooltip {
  display: flex;
  flex-direction: row;
}
.stars-container {
  width: 100px;
}
.star {
  height: 20px;
}
</style>
